import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";

import { HotelSearchConditionType } from "@/hooks/useHotelSearchCondition";
import usePlatform from "@/hooks/usePlatform";

const useCheckCondition = () => {
  const { isMobile } = usePlatform();
  const checkHotelCondition = (searchData: HotelSearchConditionType) => {
    if (searchData.items.length <= 0 || !searchData.startDate || !searchData.endDate) {
      return false;
    }
    if (searchData.startDate && searchData.endDate) {
      if (dayjs(searchData.startDate).isSame(searchData.endDate, "D")) {
        enqueueSnackbar(`Please select a different day!`, {
          variant: "info",
          anchorOrigin: {
            vertical: isMobile ? "bottom" : "top",
            horizontal: isMobile ? "center" : "right",
          },
          autoHideDuration: 2000,
        });
        return false;
      }
    }

    return true;
  };

  return { checkHotelCondition };
};

export default useCheckCondition;
